<div
    class="tw-gap-4 tw-pt-[50px] sm:tw-py-[100px] tw-px-4 xl:tw-px-0 tw-relative tw-text-white tw-bg-[#0A0A75]"
>
    <img
        class="tw-absolute tw-hidden md:tw-block tw-h-full tw-right-0 tw-top-0"
        alt="hero"
        src="/assets/images/fin-calculator/hero.png"
    />
    <div class="tw-max-w-[1240px] tw-mx-auto tw-flex">
        <form
            [formGroup]="form"
            (ngSubmit)="onSubmit()"
            class="tw-flex-1 tw-space-y-6 tw-relative tw-z-[2]"
        >
            <h1 class="tw-text-[20px] !tw-font-bold sm:!tw-text-[40px]">
                {{ "FINANCING_CALCULATOR.HEADING" | translate }}
            </h1>

            <!-- Row 1: Amount -->
            <div class="tw-flex tw-flex-col">
                <label class="tw-font-bold tw-mb-2">{{
                    "FINANCING_CALCULATOR.FIELDS.AMOUNT" | translate
                }}</label>
                <div
                    class="tw-flex tw-border-b tw-gap-2 tw-py-1 tw-border-b-white tw-bg-transparent"
                >
                    <span>RM</span>
                    <input
                        type="text"
                        placeholder="100,000"
                        formControlName="amount"
                        class="tw-bg-transparent tw-text-white"
                        (input)="onAmountInput($event)"
                        (blur)="formatAmount()"
                    />
                </div>
                <div
                    *ngIf="
                        form.get('amount')?.invalid &&
                        form.get('amount')?.touched
                    "
                    class="tw-text-red-500 tw-text-sm"
                >
                    <!-- Required -->
                    <div *ngIf="form.get('amount')?.errors?.['required']">
                        {{
                            selectedLanguage === "en"
                                ? "Amount is required."
                                : "Amaun diperlukan."
                        }}
                    </div>

                    <!-- Min -->
                    <div *ngIf="form.get('amount')?.errors?.['min']">
                        {{
                            selectedLanguage === "en"
                                ? "Minimum amount is RM 1,000."
                                : "Amaun minimum ialah RM 1,000."
                        }}
                    </div>

                    <!-- Max -->
                    <div *ngIf="form.get('amount')?.errors?.['max']">
                        {{
                            selectedLanguage === "en"
                                ? "Maximum amount is RM 20,000,000."
                                : "Amaun maksimum ialah RM 20,000,000."
                        }}
                    </div>
                </div>
            </div>

            <div
                class="tw-flex tw-flex-col-reverse md:tw-flex-row tw-gap-[30px]"
            >
                <div class="tw-flex tw-flex-col tw-flex-1 tw-gap-[30px]">
                    <div class="tw-flex-1">
                        <label class="tw-font-bold tw-mb-2"
                            >{{
                                "FINANCING_CALCULATOR.FIELDS.INTEREST"
                                    | translate
                            }}(%)</label
                        >
                        <div class="w-full tw-relative tw-mt-[15px]">
                            <span
                                class="tw-text-[12px] tw-top-[-12px] tw-absolute"
                                [style]="getPosition('interest')"
                                >{{ form.value.interestRate }}%</span
                            >
                            <input
                                type="range"
                                formControlName="interestRate"
                                [min]="interest.min"
                                [max]="interest.max"
                                [style.background]="getBackground('interest')"
                                class="tw-w-full custom-range"
                            />
                            <div
                                class="tw-flex tw-text-center tw-justify-between tw-my-1"
                            >
                                <span class="tw-text-[12px]"
                                    >{{ interest.min }}%</span
                                >
                                <span class="tw-text-[12px]"
                                    >{{ interest.max }}%</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="tw-flex-1">
                        <div class="tw-flex tw-items-center tw-gap-1">
                            <label class="tw-block tw-font-medium">{{
                                "FINANCING_CALCULATOR.FIELDS.TENURE" | translate
                            }}</label>
                            <select
                                formControlName="durationUnit"
                                class="tw-bg-transparent tw-w-fit"
                            >
                                <option class="tw-text-black" value="months">
                                    ({{
                                        "FINANCING_CALCULATOR.MONTHS"
                                            | translate
                                    }})
                                </option>
                                <option class="tw-text-black" value="years">
                                    ({{
                                        "FINANCING_CALCULATOR.YEARS"
                                            | translate
                                    }})
                                </option>
                            </select>
                        </div>

                        <div class="w-full tw-relative tw-mt-[15px]">
                            <span
                                class="tw-text-[12px] tw-top-[-12px] tw-absolute"
                                [ngClass]="{
                                    'tw-min-w-[65px]':
                                        form.value.durationUnit === 'months',
                                    'tw-min-w-[55px]':
                                        form.value.durationUnit === 'years'
                                }"
                                [style]="getPosition('duration')"
                                >{{ form.value.duration }}
                                {{ form.value.durationUnit }}</span
                            >
                            <input
                                type="range"
                                formControlName="duration"
                                [min]="duration.min"
                                [max]="duration.max"
                                [style.background]="getBackground('duration')"
                                class="tw-w-full custom-range"
                            />
                            <div
                                class="tw-flex tw-text-center tw-justify-between tw-my-1"
                            >
                                <span class="tw-text-[12px]"
                                    >{{ duration.min }}
                                    {{ form.value.durationUnit }}</span
                                >
                                <span class="tw-text-[12px]"
                                    >{{ duration.max }}
                                    {{ form.value.durationUnit }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tw-flex tw-flex-col tw-flex-1 tw-gap-[30px]">
                    <div class="tw-flex-1">
                        <label class="tw-font-bold tw-mb-2 tw-block">{{
                            "FINANCING_CALCULATOR.FIELDS.PROVIDER" | translate
                        }}</label>
                        <div class="tw-space-y-1">
                            <label class="tw-flex tw-items-center tw-gap-2">
                                <input
                                    type="checkbox"
                                    value="financing"
                                    (change)="onProviderChange($event)"
                                />
                                {{ "COMMON.FINANCING" | translate }}
                            </label>
                            <label class="tw-flex tw-items-center tw-gap-2">
                                <input
                                    type="checkbox"
                                    value="alternate-financing"
                                    (change)="onProviderChange($event)"
                                />
                                {{ "COMMON.ALTERNATE_FINANCING" | translate }}
                            </label>
                        </div>
                    </div>
                    <div class="tw-flex-1">
                        <label class="tw-font-bold tw-mb-2 tw-block">{{
                            "FINANCING_CALCULATOR.FIELDS.FIN_TYPE" | translate
                        }}</label>
                        <div class="tw-space-y-1">
                            <label class="tw-flex tw-items-center tw-gap-2">
                                <input
                                    type="checkbox"
                                    value="islamic"
                                    (change)="onFinancingTypeChange($event)"
                                />
                                {{
                                    "FINANCING_CALCULATOR.FIELDS.ISLAMIC"
                                        | translate
                                }}
                            </label>
                            <label class="tw-flex tw-items-center tw-gap-2">
                                <input
                                    type="checkbox"
                                    value="conventional"
                                    (change)="onFinancingTypeChange($event)"
                                />
                                {{
                                    "FINANCING_CALCULATOR.FIELDS.CONVENTIONAL"
                                        | translate
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Buttons -->
            <div class="tw-flex tw-gap-4">
                <button
                    ga-event-id="calculate_button_financing_calculator_click"
                    ga-event-category="Financing Calculator Button"
                    ga-event-label="Calculate Main Button Click"
                    ga-track="track"
                    type="submit"
                    class="tw-bg-[#FFAD3C] tw-text-white tw-px-[70px] tw-py-[17px] tw-rounded-full"
                >
                    {{ "FINANCING_CALCULATOR.CALCULATE" | translate }}
                </button>
                <button
                    type="button"
                    (click)="onReset()"
                    class="tw-text-white tw-px-4 tw-py-2 tw-rounded-full"
                >
                    {{ "FINANCING_CALCULATOR.RESET" | translate }}
                </button>
            </div>
            <p class="!tw-text-white">
                {{ "FINANCING_CALCULATOR.FORM_NOTE" | translate }}
                <a
                    ga-event-id="apply_now_text_financing_calculator_click"
                    ga-event-label="Financing Calculator Button"
                    ga-event-category="Apply Now Text Click"
                    ga-track="track"
                    href="/business-financing"
                    class="tw-underline"
                    >{{ "FINANCING_CALCULATOR.NOTE_CTA" | translate }}</a
                >
            </p>
        </form>

        <!-- Right Side Empty -->
        <div class="tw-flex-1"></div>
    </div>
    <img
        class="tw-block sm:tw-hidden tw-h-full tw-bottom-0 tw-mt-[50px]"
        alt="hero"
        src="/assets/images/fin-calculator/mob.png"
    />
</div>
